$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
    icons: {
        time: 'ki ki-clock',
        date: 'ki ki-calendar',
        up: 'ki ki-arrow-up',
        down: 'ki ki-arrow-down',
        previous: 'ki ki-arrow-back',
        next: 'ki ki-arrow-next',
        today: 'ki ki-calendar-today',
        clear: 'ki ki-close',
        close: 'ki ki-close'
    }
});
